import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

import { toast } from "react-toastify";
export function useBulkUpdateAdStateV2() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (vars: { ad_ids: number[]; state: "ENABLED" | "PAUSED"; marketplace: string }) => {
      const { ad_ids, state, marketplace } = vars;

      return await apiClient.setAdStateBulk({
        ad_ids: ad_ids,
        state: state,
        marketplace: marketplace,
      });
    },
    onMutate: (vars) => {
      toast.info(`Updating media plan${vars.ad_ids.length === 1 ? "" : "s"}`, {
        autoClose: false,
        toastId: "ad-status-toast",
      });
    },
    onSuccess: (data, vars) => {
      toast.update("ad-status-toast", {
        render: `Media Plan${vars.ad_ids.length > 1 ? "s" : ""} Updated`,
        type: "success",
        autoClose: 3000,
      });
      // TODO: shouldn't invalidate _all_ queries
      void queryClient.invalidateQueries();
    },
    onError: (error, vars) => {
      toast(`Failed to update Media Plan${vars.ad_ids.length === 1 ? "" : "s"}`, { type: "error" });
    },
  });
}
